import type { AuditViaDTO } from '@contracts/common';

/**
 * Who acted, as a person reads it (AI S1 spec §5.5, S8 §6.2): the name the event recorded and, when the write came
 * through the assistant, the persona it came through — "Bình (qua Mây)" — but only when the server sent that persona
 * (the actor's own rows, or the Audit page for an `audit.view` holder). Anyone else reads "Bình ✦": assisted, never
 * whose persona. The persona is the one stored at write time, so renaming it later never rewrites an old line.
 */
export const viaSuffix = (via: AuditViaDTO | null): string =>
  (via === null ? '' : via.persona === undefined ? ' ✦' : ` (qua ${via.persona})`);

export const actorLabel = (name: string, via: AuditViaDTO | null): string => `${name}${viaSuffix(via)}`;

/**
 * One owner's part of a line about assistants at work (S8 §6.2, D41): `own` is the viewer's own assistant, named by
 * the viewer's persona ("✦ Mây đang tạo 2 thẻ"); otherwise `name` is the person whose assistant it is ("An ✦ đang
 * sửa"), assisted but never whose persona. The mark is drawn from `own`, never found by looking for "✦" in a name.
 */
export type AssistedSegment = { name: string; own: boolean; text: string };
